import Header from "../../components/Header";
import ContentWrapper from "../../components/ContentWrapper";
import BoxSignsMisc from "./_components/BoxSignsMisc";

const SignsMisc = () => (
  <>
    <div className="px-[10px] pt-[5px]">
      <Header />
    </div>
    <ContentWrapper>
      <BoxSignsMisc />
    </ContentWrapper>
  </>
);

export default SignsMisc;
